const defaultState = {
  list: [],
  item: null,
  students: [],
}


const rooms = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_ROOMS':
      return {...state, list: action.data}
    case 'SET_ROOM':
      return {...state, item: action.data}
    case 'NEW_ROOM':
      return {
        ...state, 
        list: [...state.list, action.data]
      };
    case 'DELETE_ROOM':
      return {
        ...state, 
        list: state.list.filter(item => (item.id != action.data)).map(item => ({...item})),
        item: null,
      }  
    case 'UPDATE_ROOM':
      return {
        ...state, 
        list: state.list.map(item => {
          if(item.id == action.data.id){
            return {...action.data};
          }
          return {...item};
        }),
        item: action.data
      }
    case 'GET_ROOM_STUDENTS':
      return {
        ...state,
        students: action.data
      } 
    case 'ADD_ROOM_STUDENTS':
      return {
        ...state,
        students: [...state.students, ...action.data],
      }
    case 'DELETE_ROOM_STUDENT':
      return {
        ...state,
        students: [...state.students.filter(i => i.id != action.data)],
      }
    default:
      return state
  }
}

export default rooms;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/rooms.js